module.exports = __webpack_public_path__ + "img/img-brand-value-03.80319504.png";